import { render, staticRenderFns } from "./comment-item.vue?vue&type=template&id=bf57cc90&"
import script from "./comment-item.vue?vue&type=script&lang=js&"
export * from "./comment-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports